import { render, staticRenderFns } from "./StructureItem.vue?vue&type=template&id=45d48ff9&"
import script from "./StructureItem.vue?vue&type=script&lang=js&"
export * from "./StructureItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports